// assets
import {
    IconKey,
    IconBrandCashapp,
    IconCash,
    IconLockOpen,
    IconBuildingBank,
    IconPigMoney,
    IconNotebook,
    IconBusinessplan,
    IconCreditCard,
    IconCreditCardOff,
    IconClipboardList,
    IconListCheck,
    IconNotes,
    IconReport,
    IconScale,
} from "@tabler/icons";

// constant
const icons = {
    IconKey,
    IconBrandCashapp,
    IconCash,
    IconLockOpen,
    IconBuildingBank,
    IconPigMoney,
    IconNotebook,
    IconBusinessplan,
    IconCreditCard,
    IconCreditCardOff,
    IconClipboardList,
    IconListCheck,
    IconNotes,
    IconReport,
    IconScale,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
    id: "transaccional",
    title: "Transaccional",
    type: "group",
    children: [
        {
            id: "socios",
            title: "Movimientos",
            type: "collapse",
            icon: icons.IconBrandCashapp,

            children: [{
                id: "AperturaCaja",
                title: "AperturaCaja",
                type: "item",
                url: "/home/AperturaCaja",
                icon: icons.IconLockOpen,
            },
            {
                id: "Caja",
                title: "Caja",
                type: "item",
                url: "/home/Caja",
                icon: icons.IconCash,
            },
            {
                id: "EstadoCuenta",
                title: "Estado Cuenta",
                type: "item",
                url: "/home/EstadoCuenta",
                icon: icons.IconPigMoney,
            },
            {
                id: "CajaArchivo",
                title: "Caja Archivo",
                type: "item",
                url: "/home/CajaArchivo",
                icon: icons.IconNotebook,
            },
            ],
        },
        {
            id: "Transacción",
            title: "Créditos",
            type: "collapse",
            icon: icons.IconBusinessplan,

            children: [{
                id: "solicitud",
                title: "Solicitud",
                type: "item",
                url: "/home/solicitudCredito",
                icon: icons.IconCreditCard,
            },
            {
                id: "aprobarNegar",
                title: "Aprobar Negar Créditos",
                type: "item",
                url: "/home/AprobarNegar",
                icon: icons.IconCreditCard,
            },
            {
                id: "PagoCredito",
                title: "Pago Credito",
                type: "item",
                url: "/home/PagoCredito",
                icon: icons.IconCreditCardOff,
            },
            {
                id: "PagoAnticipados",
                title: "Pago Anticipados",
                type: "item",
                url: "/home/PagoAnticipado",
                icon: icons.IconCreditCardOff,
            },
            ],
        },
        // Modulo de tesoreria
        {
            id: "tesoreria",
            title: "Tesorería",
            type: "collapse",
            icon: icons.IconClipboardList,

            children: [{
                id: "solicitud",
                title: "Registro",
                type: "item",
                url: "/home/gastos",
                icon: icons.IconNotebook,
            },
            ],
        },
        {
            id: "contabilida",
            title: "Contabilidad",
            type: "collapse",
            icon: icons.IconListCheck,

            children: [
                {
                    id: "registro",
                    title: "Plan de cuentas",
                    type: "item",
                    url: "/home/planCuenta",
                    icon: icons.IconNotes,
                },
                {
                    id: "registroProceso",
                    title: "Procesos Contables",
                    type: "item",
                    url: "/home/procesoContable",
                    icon: icons.IconNotes,
                },
                {
                    id: "registroDestalle",
                    title: "Detalle Procesos Contables",
                    type: "item",
                    url: "/home/detailProcesoContable",
                    icon: icons.IconNotes,
                },
            ],
        },

        {
            id: "reporteria",
            title: "Reporteria",
            type: "collapse",
            icon: icons.IconReport,

            children: [
                {
                    id: "balance",
                    title: "Balance General",
                    type: "item",
                    url: "/home/balanceGeneral",
                    icon: icons.IconScale,
                },
            ],
        },
    ],
};

export default pages;